import { Autocomplete, Checkbox, Chip, Grid, TextField } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import styles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import fieldStyles from './../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowCreate.module.scss' 
import waCampaignStyles from "../../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import globalStyles from './../../../../assets/styles/global.module.scss'
import Required from '../../../utility/required';
import { WorkflowContext, WorkflowContextPayload } from '../../../../context/workflowContext';
import { IntegrationContext, IntegrationContextPayload } from '../../../../context/integrationContext';
import { chatbot_step_deployment_trigger_data, chatbotIntegratedChannelDeploymentInstagramObj, chatbotIntegratedChannelDeploymentObj, metaIntegrationFaceBookDataNew, metaIntegrationPhoneNumberDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { filterAutocompleteOptionsWithException, generateUUID } from '../../../../utils/constants';
import { isInstagramChannel, isWhatsAppChannel } from '../../../../pages/ruleBasedInbox/channelConstants';
import GlobalButton from '../../../utility/globalButton/button';
import GlobalTooltip from '../../../utility/tooltip/globalTooltip';
import IconsColor from '../../../utility/iconsColor';
import { primaryColor } from '../../../../utils/colors';
import CloseIcon from '@mui/icons-material/Close';
import { isCurrentViewVersionPublished } from '../utilityFunctions';
import { saveDeploymentInformationPayload } from '../../../../models/flowBuilderTypes';
import { checkDisableTriggerKeywordsAndDefault, hours, isMinuteDisabled, minutes, validateTime } from '../flowBuilderConstants';
import { renderIntegrationOption } from '../../workflow/workflowConstants';
import { useGenericStore } from '../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { isInstagramIntegration, isWhatsAppIntegration } from '../../../../pages/ruleBasedInbox/utils';

interface whatsAppOptionType {
    waba_name?: string;
    channel_name?: string;
    waba_id?: number;
}

interface instagramOptionType {
    instagram_account_name?: string;
    channel_name?: string;
    meta_integration_instagram_id?: number;
}

const TriggerDeploymentInfo = () => {
    
    const { workflowIntegrationList, currentActiveStaticWorkflow, setCurrentActiveStaticWorkflow, updateChatbotDeploymentDetails } = useContext(WorkflowContext) as WorkflowContextPayload;
    const { integrationListNewStructure, getMetaIntegrationList } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setFlagLoading, handleError, userDetail } = useContext(UserContext) as UserContextPayload;
    
    const integrationChannel = workflowIntegrationList?.find((integrationList) => integrationList.channel_id == Number(currentActiveStaticWorkflow?.chatbot_channel?.channel_id));

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))
    
    const [typedTriggerValue, setTypedTriggerValue] = useState<string>("");
    const [flagDefaultChatbot, setFlagDefaultChatbot] = useState<boolean>(currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version?.chatbot_version_status_name?.toLowerCase() == currentActiveStaticWorkflow?.currentViewVersion?.toLowerCase())?.chatbot_step_deployment_trigger_data?.find((trigger) => !(trigger?.condition_group)) ? true : false) 

    const whatsAppChannel = currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentObj | undefined;
    const instagramChannel = currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.[0] as chatbotIntegratedChannelDeploymentInstagramObj | undefined;

    const deploymentChannelName = currentActiveStaticWorkflow?.chatbot_channel?.channel_name;
    const isInstagram = isInstagramChannel(deploymentChannelName);
    const isWhatsApp = isWhatsAppChannel(deploymentChannelName);

    const getInitialChannelConfiguration = () => {
        const channelContentTypeId = Number(currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.deployment_channel_content_type_data?.channel_content_type_id) || null;

        if (isInstagram) {
            return {
                integrated_channel_id: instagramChannel?.integrated_channel_id != null ? String(instagramChannel.integrated_channel_id) : "",
                meta_integration_instagram_id: instagramChannel?.meta_integration_instagram_id || null,
                channel_content_type_id: channelContentTypeId,
            };
        }

        return {
            integrated_channel_id: whatsAppChannel?.meta_integration_whatsapp_phone_number_data?.[0]?.integrated_channel_id || "",
            meta_integration_whatsapp_id: whatsAppChannel?.meta_integration_whatsapp_id || null,
            channel_content_type_id: channelContentTypeId,
        };
    };
    
    const [payload, setPayload] = useState<saveDeploymentInformationPayload>({
        chatbot_id: currentActiveStaticWorkflow?.chatbot_id || "",
        chatbot_name: currentActiveStaticWorkflow?.chatbot_name || "",
        chatbot_channel_configuration: getInitialChannelConfiguration(),
        chatbot_step_deployment_trigger_data: currentActiveStaticWorkflow?.chatbot_version_info?.find((version) => version.chatbot_version_status_name.toLowerCase() == currentActiveStaticWorkflow.currentViewVersion.toLowerCase())?.chatbot_step_deployment_trigger_data.map((trigger) => {
            return {
                ...trigger, 
                chatbot_step_deployment_trigger_data_id: trigger.chatbot_step_deployment_trigger_data_id,
                condition_group: trigger.condition_group ? {
                    condition_type: trigger.condition_group.condition_type,
                    condition_values: trigger.condition_group?.condition_values,  
                    flag_advanced_condition: trigger.condition_group?.flag_advanced_condition,
                } : null,
            }
        }) || [], 
        chatbot_thread_timeout_config: currentActiveStaticWorkflow?.chatbot_thread_timeout_config || {
            chatbot_id: "", 
            chatbot_thread_timeout_config_id: "", 
            timeout_type: "relative_to_last_message", 
            timeout_duration: {
                day: "", hour: "", min: "", sec: ""
            }
        },
    })

    const getWhatsAppNumberOptions = () => {
        if (!integrationListNewStructure) return [];

        return integrationListNewStructure.filter(isWhatsAppIntegration)
            .find((waba: metaIntegrationWhatsAppDataNew) => waba.meta_integration_whatsapp_id == payload.chatbot_channel_configuration?.meta_integration_whatsapp_id)
            ?.meta_integration_phone_number_data || [];
    }

    const getWhatsAppNumberValue = () => {
        const options = getWhatsAppNumberOptions();
        return options.find((phoneNumberData: metaIntegrationPhoneNumberDataNew) => String(phoneNumberData.integrated_channel_id) == payload.chatbot_channel_configuration.integrated_channel_id) || null;
    }

    const onChangeOfWBA = (value: metaIntegrationWhatsAppDataNew | null) => {
        if (value && Number(value.waba_id) === -1) {
            window.open(`${window.location.origin}/channels/viewintegration/whatsapp`, "_blank");
            return;
        }

        setPayload((prev) => ({
            ...prev, 
            chatbot_channel_configuration: {
                ...prev.chatbot_channel_configuration, 
                meta_integration_whatsapp_id: value ? value.meta_integration_whatsapp_id : null, 
                integrated_channel_id: "",
            }
        }))
    }

    const onChangeOfInstagramAccount = (value: metIntegrationInstagramDataNew | null) => {
        if (value && Number(value.meta_integration_instagram_id) === -1) {
            window.open(`${window.location.origin}/channels/viewintegration/instagram`, "_blank");
            return;
        }

        setPayload((prev) => ({
            ...prev,
            chatbot_channel_configuration: {
                ...prev.chatbot_channel_configuration,
                meta_integration_instagram_id: value ? value.meta_integration_instagram_id : null,
                integrated_channel_id: value?.integrated_channel_id != null ? String(value.integrated_channel_id) : "",
            }
        }))
    }

    const onChangeOfPhoneNumber = (value: metaIntegrationPhoneNumberDataNew | null) => {
        setPayload((prev) => ({
            ...prev, 
            chatbot_channel_configuration: {
                ...prev.chatbot_channel_configuration, 
                integrated_channel_id: value ? String(value.integrated_channel_id) : "",
            }
        }))
    }

    const getIntegrationListApiCall = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }));
        const res = await getMetaIntegrationList(true)
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }));
    }

    useEffect(() => {
        (async () => {
            if (!integrationListNewStructure) {
                await getIntegrationListApiCall();
            }
        })()
    }, [])

    const SaveTriggerDisabled = () => { 
        const triggerKeywordValues = payload.chatbot_step_deployment_trigger_data.find((trigger) => trigger.condition_group && trigger.condition_group.condition_type?.toLowerCase() === "static_value_check")?.condition_group?.condition_values || [];
        const noTriggerKeywords = !Array.isArray(triggerKeywordValues) || triggerKeywordValues.length === 0;

        const hasChannelIntegration = isInstagram
            ? !!payload.chatbot_channel_configuration?.meta_integration_instagram_id
            : !!payload.chatbot_channel_configuration?.meta_integration_whatsapp_id;

        if(!hasChannelIntegration 
            || !payload.chatbot_channel_configuration?.channel_content_type_id 
            || payload.chatbot_channel_configuration.integrated_channel_id?.length == 0 
            || (!flagDefaultChatbot && noTriggerKeywords)
         )
        {
            return true;
        }
        else {
            return false
        }

    } 

    async function saveChatbotDeploymentInformation() {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true })); 
        let updatedPayload = payload; 
        if(flagDefaultChatbot) {
            if(!updatedPayload.chatbot_step_deployment_trigger_data.find((trigger) => !(trigger.condition_group))){
                const defaultConditionObj: chatbot_step_deployment_trigger_data = {
                    chatbot_step_deployment_trigger_data_id: generateUUID(),
                    condition_group: null,
                }

                updatedPayload = {
                    ...updatedPayload, 
                    chatbot_step_deployment_trigger_data: [...updatedPayload.chatbot_step_deployment_trigger_data, defaultConditionObj],
                }
            }
        } else {
            if(updatedPayload.chatbot_step_deployment_trigger_data.find((trigger) => !(trigger.condition_group))){
                updatedPayload = {
                    ...updatedPayload, 
                    chatbot_step_deployment_trigger_data: updatedPayload.chatbot_step_deployment_trigger_data.filter((trigger) => trigger.condition_group),
                }
            }
        }
        if(updatedPayload.chatbot_step_deployment_trigger_data.find((trigger) => trigger.condition_group && trigger.condition_group.condition_type?.toLowerCase() == "static_value_check" && trigger.condition_group.condition_values?.length == 0)){
            updatedPayload = {
                ...updatedPayload, 
                chatbot_step_deployment_trigger_data: updatedPayload.chatbot_step_deployment_trigger_data.filter((trigger) => !(trigger.condition_group && trigger.condition_group.condition_type?.toLowerCase() == "static_value_check" && trigger.condition_group.condition_values?.length == 0)),
            }
        } 

        const updatedStepDeploymentTriggerData = updatedPayload.chatbot_step_deployment_trigger_data.map((trigger) => {
            if(!(trigger.chatbot_step_deployment_trigger_data_id)){
                return {
                    ...trigger, 
                    chatbot_step_deployment_trigger_data_id: generateUUID(),
                }
            }
            return trigger;
        });
        updatedPayload = {
            ...updatedPayload, 
            chatbot_step_deployment_trigger_data: updatedStepDeploymentTriggerData,
        } 
        setPayload((prev) => updatedPayload);
        const response = await updateChatbotDeploymentDetails(updatedPayload); 
        if(response.status){
            showSuccess('Deployment Information saved successfully!')
            if (response.status && response.data) {
                setCurrentActiveStaticWorkflow((prev: any) => ({
                    ...prev, 
                    chatbot_integrated_channel_deployment: response.data?.[0]?.chatbot_integrated_channel_deployment,  
                    chatbot_thread_timeout_config: response.data?.[0]?.chatbot_thread_timeout_config, 
                    chatbot_version_info: prev?.chatbot_version_info?.map((version: any) => {
                        if(version.chatbot_version_status_name?.toLowerCase() == prev?.currentViewVersion?.toLowerCase()){
                            return {
                                ...version, 
                                chatbot_step_deployment_trigger_data: updatedStepDeploymentTriggerData,
                            }
                        }
                        return version;
                    })
                }))
            }
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false })); 
    }

    const handleOnChangeOfTriggerValues = (filtered: string[]) => {
        if(payload.chatbot_step_deployment_trigger_data.find((trigger) => trigger.condition_group && trigger.condition_group?.condition_type?.toLowerCase() == "static_value_check")){
            setPayload((prev) => ({
                ...prev, 
                chatbot_step_deployment_trigger_data: prev?.chatbot_step_deployment_trigger_data?.map((trigger) => {
                    if(trigger.condition_group && trigger.condition_group?.condition_type?.toLowerCase() == "static_value_check"){
                        return {
                            ...trigger, 
                            condition_group: {
                                ...trigger.condition_group, 
                                condition_values: filtered,
                            }, 
                            chatbot_step_deployment_trigger_data_id: filtered?.length == 0 ? "" : trigger.chatbot_step_deployment_trigger_data_id,
                        }
                    }
                    return trigger; 
                })
            }))
        } else { 
            const obj: chatbot_step_deployment_trigger_data = {
                chatbot_step_deployment_trigger_data_id: "", 
                condition_group: {
                    condition_values: filtered, 
                    condition_type: "static_value_check", 
                    flag_advanced_condition: false,
                }
            }
            setPayload((prev) => ({
                ...prev, 
                chatbot_step_deployment_trigger_data: [...prev.chatbot_step_deployment_trigger_data, obj],
            }))
        }
    } 

    const onChangeOfResetTimer = (type: string, value: string) => {
        let current_hour = payload?.chatbot_thread_timeout_config?.timeout_duration?.hour; 
        let current_min =  payload?.chatbot_thread_timeout_config?.timeout_duration?.min;

        const {new_min, new_hour} = validateTime(type, value, current_min, current_hour);
        
        setPayload((prev) => ({
            ...prev, 
            chatbot_thread_timeout_config: {
                ...prev?.chatbot_thread_timeout_config, 
                timeout_duration:  {
                    ...prev.chatbot_thread_timeout_config?.timeout_duration, 
                    hour: new_hour, 
                    min: new_min,
                }
            }
        }))
    }

    const checkDisableTriggerKeywords = (triggerType: string) => {
        const keywordsValue = payload.chatbot_step_deployment_trigger_data.find((trigger) => trigger.condition_group && trigger.condition_group.condition_type?.toLowerCase() == "static_value_check")?.condition_group?.condition_values || [];
        return checkDisableTriggerKeywordsAndDefault(triggerType, keywordsValue, flagDefaultChatbot); 
    }

    const whatsAppOptions = [
        ...(integrationListNewStructure?.filter(isWhatsAppIntegration) || []),
        { waba_name: "default", channel_name: "WhatsApp", waba_id: -1 }
    ];

    const instagramOptions = [
        ...(integrationListNewStructure?.filter(isInstagramIntegration) || []),
        { instagram_account_name: "default", channel_name: "Instagram", meta_integration_instagram_id: -1 }
    ];

    // Render Custom Deployment Info
    const renderWhatsAppDeploymentInfo = () => {
        return (
            <>
                {/* WhatsApp Business Account */}
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container direction={"column"} gap={"10px"}>
                        <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                            WhatsApp Business Account <Required />
                        </Grid>
                        
                        <Grid item>
                            <Autocomplete
                                disabled={currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data && currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.length > 0 ? true : false}
                                className={`${globalStyles.autocompleteParaphrasing} ${fieldStyles.autoComplete} ${styles.deploymentInfoFields}`}
                                options={whatsAppOptions}
                                getOptionLabel={(option: any) => option.waba_name ? option.waba_name : ""}
                                value={integrationListNewStructure?.filter(isWhatsAppIntegration)?.find((waba) => waba.meta_integration_whatsapp_id == payload.chatbot_channel_configuration.meta_integration_whatsapp_id)}
                                onChange={(_, value: metaIntegrationWhatsAppDataNew | whatsAppOptionType | null) => { onChangeOfWBA(value as metaIntegrationWhatsAppDataNew | null); }}
                                isOptionEqualToValue={(option: any, value: any) => option?.meta_integration_whatsapp_id == value?.meta_integration_whatsapp_id}
                                renderInput={(params) => <TextField {...params} placeholder="Select WhatsApp Business Account" />}
                                renderOption={(props, option) => renderIntegrationOption(props, option)}
                                filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "waba_name", "waba_id")}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                {/* WhatsApp Business Phone Number */}
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container direction={"column"} gap={"10px"}>
                        <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                            WhatsApp Business Phone Number <Required />
                        </Grid>
                        
                        <Grid item>
                            <Autocomplete
                                disabled={!(payload.chatbot_channel_configuration.meta_integration_whatsapp_id) || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                className={`${globalStyles.autocompleteParaphrasing} ${fieldStyles.autoComplete}`}
                                options={getWhatsAppNumberOptions()}
                                getOptionLabel={(option) => option.display_phone_number}
                                value={getWhatsAppNumberValue()}
                                onChange={(_, value: metaIntegrationPhoneNumberDataNew | null) => { onChangeOfPhoneNumber(value); }}
                                renderInput={(params) => <TextField {...params} placeholder="Select WhatsApp Number" />}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }

    const renderInstagramDeploymentInfo = () => {
        return (
            <>
                {/* Instagram Business Account */}
                <Grid item className={globalStyles.fullwidth}>
                    <Grid container direction={"column"} gap={"10px"}>
                        <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                            Instagram Business Account <Required />
                        </Grid>
                        
                        <Grid item>
                            <Autocomplete
                                disabled={currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data && currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.integrated_channel_data?.length > 0 ? true : false}
                                className={`${globalStyles.autocompleteParaphrasing} ${fieldStyles.autoComplete} ${styles.deploymentInfoFields}`}
                                options={instagramOptions}
                                getOptionLabel={(option: any) => option.instagram_account_name ? option.instagram_account_name : ""}
                                value={integrationListNewStructure?.filter(isInstagramIntegration)?.find((instagram) => instagram.meta_integration_instagram_id == payload.chatbot_channel_configuration.meta_integration_instagram_id)}
                                onChange={(_, value: metIntegrationInstagramDataNew | instagramOptionType | null) => { onChangeOfInstagramAccount(value as metIntegrationInstagramDataNew | null); }}
                                isOptionEqualToValue={(option: any, value: any) => option?.meta_integration_instagram_id == value?.meta_integration_instagram_id}
                                renderInput={(params) => <TextField {...params} placeholder="Select Instagram Business Account" />}
                                renderOption={(props, option) => renderIntegrationOption(props, option, "Instagram")}
                                filterOptions={(options, state) => filterAutocompleteOptionsWithException(options, state, "instagram_account_name", "meta_integration_instagram_id")}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </>
        )
    }

    return (
        <Grid item className={styles.bodyFormComponents}>
            <Grid container direction={"column"} gap={3}>

                <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                    Deployment Information
                </Grid>

                <Grid item>
                    <Grid container direction={"column"} gap={2}>
                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container direction={"column"} gap={"10px"}>
                                <Grid item className={fieldStyles.createWorkflowLabelStyle}>Deployment Channel <Required /></Grid>
                                <Grid item>
                                    <Autocomplete
                                        disabled
                                        className={`${globalStyles.autocompleteParaphrasing} ${fieldStyles.autoComplete} ${styles.deploymentInfoFields}`}
                                        value={workflowIntegrationList?.find((option) => option.channel_id == Number(currentActiveStaticWorkflow?.chatbot_channel?.channel_id)) || null}
                                        options={workflowIntegrationList || []}
                                        getOptionLabel={(option) => option.channel_name}
                                        renderInput={(params) => <TextField {...params} placeholder='Select Deployment Channel...' />}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        {isWhatsApp && (
                            renderWhatsAppDeploymentInfo()
                        )}

                        {isInstagram && (
                            renderInstagramDeploymentInfo()
                        )}

                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container direction={"column"} gap={"10px"}>
                                <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                    Content Type <Required />
                                </Grid>
                                
                                <Grid item>
                                    <Autocomplete
                                        disabled={payload.chatbot_channel_configuration.channel_content_type_id ? true : false}
                                        className={`${globalStyles.autocompleteParaphrasing} ${fieldStyles.autoComplete} ${styles.deploymentInfoFields}`}
                                        options={integrationChannel?.channel_content_types || []}
                                        getOptionLabel={(option: any) => option.channel_content_type_name ? option.channel_content_type_name : ""}
                                        value={currentActiveStaticWorkflow?.chatbot_integrated_channel_deployment?.deployment_channel_content_type_data}
                                        renderInput={(params) => <TextField {...params} placeholder="Select Content Type" />}
                                    />
                                </Grid>
                            </Grid>
                        </Grid> 

                        {/* Trigger Keywords */}
                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container direction={"column"} gap={"10px"}>
                                <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                    Do you need to trigger this chatbot on any special keyword?
                                </Grid>

                                <Grid item>
                                    <Autocomplete   
                                        className={`${waCampaignStyles.whatsappCampaignDropDowns} ${globalStyles.fullwidth} ${waCampaignStyles.actionAutoComplete} ${waCampaignStyles.actionUserReplyAutoComplete} ${fieldStyles.triggerValueFreeSolo}`}
                                        freeSolo
                                        options={[]}
                                        multiple
                                        value={payload.chatbot_step_deployment_trigger_data.find((trigger) => trigger.condition_group && trigger.condition_group.condition_type?.toLowerCase() == "static_value_check")?.condition_group?.condition_values || []}
                                        inputValue={typedTriggerValue} 
                                        onInputChange={(e, val) => {
                                            setTypedTriggerValue(val);
                                        }}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip
                                                    label={option}
                                                    deleteIcon={<CloseIcon />}
                                                    {...getTagProps({ index })}
                                                    sx={{
                                                        whiteSpace: "normal", 
                                                        wordBreak: "break-word",
                                                        padding: "4px 0px",
                                                        height: "auto",
                                                    }}
                                                />
                                            ))
                                        }
                                        onChange={(e, newValue) => { 
                                            const filtered = newValue.filter((val) => typeof val === "string" && val.trim().length > 0);
                                            handleOnChangeOfTriggerValues(filtered);
                                        }} 
                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || checkDisableTriggerKeywords("keyword")}
                                        renderInput={params => {
                                            const { InputProps, ...restParams } = params;
                                            const { startAdornment, ...restInputProps } = InputProps;
                                            return (
                                                <TextField
                                                    {...restParams}
                                                    placeholder='Enter Trigger Keywords' 
                                                    onBlur={() => {
                                                        if(typedTriggerValue.trim()?.length > 0){ 
                                                            const currentVal = payload.chatbot_step_deployment_trigger_data.find((trigger) => trigger.condition_group && trigger.condition_group.condition_type?.toLowerCase() == "static_value_check")?.condition_group?.condition_values || [];
                                                            if(!currentVal.find((val) => val == typedTriggerValue.trim())){
                                                                const newVal = [...currentVal, typedTriggerValue.trim()];
                                                                handleOnChangeOfTriggerValues(newVal);
                                                                setTypedTriggerValue(""); 
                                                            }
                                                        }
                                                    }}
                                                    InputProps={{
                                                        ...restInputProps,
                                                        startAdornment: (
                                                            <div className={waCampaignStyles.renderInputDivOfUserReplyOfAction}>
                                                                {startAdornment}
                                                            </div>
                                                        ),
                                                    }}
                                                />
                                            );
                                        }}
                                    />
                                </Grid>

                                {typedTriggerValue.trim().length > 0 && 
                                    <Grid item className={fieldStyles.pressEnterTypography} sx={{whiteSpace: "normal", wordBreak: "break-all"}}>
                                        Press Enter to save {typedTriggerValue}
                                    </Grid>
                                }
                            </Grid>
                        </Grid> 

                        {/* Default chatbot */}
                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container gap={"10px"} alignItems={"center"} flexWrap={"nowrap"}>
                                <Grid item>
                                    <Checkbox
                                        className={`${waCampaignStyles.checkBoxFilter} ${checkDisableTriggerKeywords("default") ? waCampaignStyles.defaultDisabledChatbotCheckBox : waCampaignStyles.defaultChatbotCheckBox}`}
                                        checked={flagDefaultChatbot}
                                        disableRipple 
                                        disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow) || checkDisableTriggerKeywords("default")}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFlagDefaultChatbot(e.target.checked)}
                                    />
                                </Grid>

                                <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                    Use this as a default chatbot (If no trigger matches)
                                    <GlobalTooltip
                                        arrow
                                        placement='top'
                                        title={`Enable this if you want this chatbot to resopnd when no specific keyword or rule applies.`}
                                    >
                                        <span className={`${globalStyles.clickable} ${waCampaignStyles.chatbotStepIButton}`}>
                                            <IconsColor fillColor={primaryColor} iconName="info" height={"14"} width={"14"} />
                                        </span>
                                    </GlobalTooltip>
                                </Grid>
                            </Grid>
                        </Grid> 

                        {/* Reset Thread Timer */}
                        <Grid item className={globalStyles.fullwidth}>
                            <Grid container gap={"18px"} direction={"column"}>
                                <Grid item className={fieldStyles.createWorkflowLabelStyle}>
                                    Automatically Reset the thread after
                                </Grid>

                                <Grid item>
                                    <Grid container gap={2} alignItems={"center"}>
                                        <Grid item>
                                            <Autocomplete
                                                className={`${globalStyles.autocompleteParaphrasing} ${fieldStyles.autoComplete}`}
                                                options={hours} 
                                                disableClearable
                                                value={String(payload?.chatbot_thread_timeout_config?.timeout_duration?.hour) ?? null}
                                                onChange={(e, newValue) => onChangeOfResetTimer("hour", newValue)}
                                                getOptionLabel={(option) => String(option).padStart(2, '0')}
                                                isOptionEqualToValue={(option, value) => option === value}
                                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                renderInput={(params) => (
                                                    <TextField 
                                                        {...params} 
                                                        label="Hour" 
                                                        variant="outlined" 
                                                        size="small"  
                                                        className={fieldStyles.resetThreadTimerTextField}
                                                    />
                                                )}
                                                size="small"
                                            />
                                        </Grid>

                                        <Grid item>
                                            <Autocomplete
                                                className={`${globalStyles.autocompleteParaphrasing} ${fieldStyles.autoComplete}`}
                                                options={minutes} 
                                                disableClearable
                                                value={String(payload?.chatbot_thread_timeout_config?.timeout_duration?.min) ?? null}
                                                onChange={(e, newValue) =>  onChangeOfResetTimer("min", newValue)}
                                                getOptionLabel={(option) => String(option).padStart(2, '0')}
                                                isOptionEqualToValue={(option, value) => option === value} 
                                                getOptionDisabled={(option) => isMinuteDisabled(option, payload?.chatbot_thread_timeout_config?.timeout_duration?.hour)}
                                                disabled={isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                                                renderInput={(params) => (
                                                    <TextField 
                                                        {...params} 
                                                        label="Minute" 
                                                        variant="outlined" 
                                                        size="small" 
                                                        className={fieldStyles.resetThreadTimerTextField}
                                                    />
                                                )}
                                                size="small"
                                            />
                                        </Grid> 
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>

                {/* Save Button */}
                <Grid item sx={{ textAlign: "center" }}>
                    <GlobalButton
                        buttonText="Save"
                        className='primaryButtonStyle'
                        sx={{ width: "100px" }}
                        disabled={SaveTriggerDisabled() || isCurrentViewVersionPublished(currentActiveStaticWorkflow)}
                        onClick={saveChatbotDeploymentInformation}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default TriggerDeploymentInfo
